/**
 * 金额格式化
 * @param {Number|String} amount 金额
 * @param {Number} digits 小数位数，默认0
 * @param {String} unit 单位，默认空
 * @returns {String} 格式化后的金额
 */
export function formatAmount(amount, digits = 0, unit = '') {
  // if (amount === null || amount === undefined || amount === '') {
  //   return `0${unit}`
  // }
  // const formatted = Number(amount).toLocaleString('zh-CN', {
  //   minimumFractionDigits: digits,
  //   maximumFractionDigits: digits
  // })
  // return `${formatted}${unit}`
  
   // 转换为数字
    const num = parseFloat(amount) || 0;
    
    // 四舍五入到指定小数位
    const fixed = num.toFixed(digits);
    
    // 分割整数和小数部分
    const parts = fixed.toString().split('.');
    const integerPart = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    const decimalPart = parts[1] ? `.${parts[1]}` : '';
    
    return `${integerPart}${decimalPart}${unit}`;
}


